module.exports = __webpack_public_path__ + "img/news_2.49f6cf69.png";